import React, { ReactElement } from 'react'
import { Flex, Icon, IconType, Text } from '@mindfulchefuk/design-system'

type TReasonToJoin = {
  icon: IconType
  text: string
}

export const ReasonToJoin = ({ icon, text }: TReasonToJoin): ReactElement => (
  <Flex alignContent="center" alignItems="center">
    <Icon type={icon} mr={12} />
    <Text variant="body-md" display="inline" position="relative">
      {text}
    </Text>
  </Flex>
)
